import { COUNTRY_CODES } from '@app/shared'
import { useMemo } from 'react'

/**
 * Countries by their own reader's name for them, so the list needs no
 * translating and sorts the way that reader expects.
 *
 * Where the runtime cannot name a region the code stands in. `US` is a poorer
 * label than `United States` and it still picks the right country.
 *
 * One list, because a second one is the copy that goes stale: the account's own
 * country and the country a card is billed in are the same question asked twice.
 */
export function useCountryOptions(): { value: string; label: string }[] {
  return useMemo(() => {
    const naming =
      typeof Intl.DisplayNames === 'function'
        ? new Intl.DisplayNames(undefined, { type: 'region' })
        : null
    return COUNTRY_CODES.map((code) => ({
      value: code as string,
      label: naming?.of(code) ?? code,
    })).sort((a, b) => a.label.localeCompare(b.label))
  }, [])
}
